import { render, staticRenderFns } from "./MarkTable.vue?vue&type=template&id=9c344298&scoped=true&"
import script from "./MarkTable.vue?vue&type=script&lang=js&"
export * from "./MarkTable.vue?vue&type=script&lang=js&"
import style0 from "./MarkTable.vue?vue&type=style&index=0&id=9c344298&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c344298",
  null
  
)

export default component.exports